<template>
  <div>
    <v-row>
      <v-col class="periodo elevation-3">
        <div :href="periodo.nombre" ref="{{periodo.nombre}}" :id="periodo.nombre">{{periodo.nombre}}</div>
      </v-col>
    </v-row>
    <template v-for="(materia, i) in periodo.materias">
      <itemMateria :key="i" :materia="materia" />
    </template>
  </div>
</template>

<script>
import itemMateria from "./itemMateria";

export default {
  data() {
    return {};
  },
  components: {
    itemMateria
  },
  props: ["periodo"],
  mounted: function() {
    //console.log("mounted -> itemMateria", this.periodo, this.periodo.length);
  },
  methods: {},
  watch: {}
};
</script>

<style scoped>
.periodo {
  padding: 30px 0 10px 30px;
  font-size: 18px;
  border-top: 2px solid #000;
  border-bottom: 1px solid #ccc;
  background-color: #bbb;
}
</style>